import { render, staticRenderFns } from "./widgetClassDropdown.vue?vue&type=template&id=4bd6767a"
import script from "./widgetClassDropdown.vue?vue&type=script&lang=js"
export * from "./widgetClassDropdown.vue?vue&type=script&lang=js"
import style0 from "./widgetClassDropdown.vue?vue&type=style&index=0&id=4bd6767a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports